import React from 'react';
import { Button } from '@cp/ds/src/components/button';
import { ButtonProps } from '@cp/ds/src/components/button/model';
import { cx } from '@emotion/css';
import { EButtonName, withTrackClick } from 'src/shared/tracking';
import { ClientSelection } from 'src/entities/client';
import { useAuth } from '../model';
import { LoginButtonClickEvent } from '../lib';

export interface LoginButtonProps extends ButtonProps {
  clientSelection?: ClientSelection;
}

const TButton = withTrackClick(Button, LoginButtonClickEvent);

export const LoginButton = ({ clientSelection, ...props }: LoginButtonProps) => {
  const auth = useAuth();
  return (
    <TButton
       
      children="Войти"
      onClick={() => auth(clientSelection)}
      size="small"
      variant="secondary"
      {...props}
      className={cx(EButtonName.Login, props.className)}
    />
  );
};
